import { useState } from 'react'
import { useSelector } from 'react-redux'
import { companyIdSelector } from 'ducks/user'
import { createMultipleUsersService } from 'views/screens/Platform-administrator/services'

const DEFAULT_EVALUATED_USER_ROLE_TYPE = 4

interface UserData {
  firstName?: string
  lastName?: string
  first_name?: string
  last_name?: string
  document: string
  email: string
  documentType: number
  reason?: string
}

interface Result {
  user: UserData
  status: string
  error?: any
}

const useCreateUsersBatch = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<any>(null)
  const [resultsSucess, setResultsSucces] = useState<UserData[]>([])
  const [resultsExisting, setResultsExisting] = useState<UserData[]>([])
  const [resultsFail, setResultsFail] = useState<Result[]>([])
  const [urlExcelUsersFailed, setUrlExcelUsersFailed] = useState<string>('')

  const companyId = useSelector(companyIdSelector)

  const createUsersBatch = async (users: UserData[], process_id?: number) => {
    setLoading(true)
    setError(null)
    setResultsSucces([])
    setResultsFail([])

    const userList = users.map((user: UserData) => {
      return {
        first_name: user.firstName,
        last_name: user.lastName,
        document: user.document.toString().trim(),
        email: user.email.toLowerCase(),
        document_type: user.documentType,
        role_type: DEFAULT_EVALUATED_USER_ROLE_TYPE,
        company_id: companyId,
      }
    })

    const body = {
      users: userList,
      process_id,
    }

    try {
      const response = await createMultipleUsersService(body)

      const resultsSuccess = response.data.createdUsers.map((user) => {
        return {
          id: user.user_id,
          userId: user.user_id,
          firstName: user.first_name,
          lastName: user.last_name,
          document: user.document,
          email: user.email,
          documentType: user.document_type,
        }
      })

      const existingUsers = response.data.existingUsers.map((user) => {
        return {
          id: user.user_id,
          userId: user.user_id,
          first_name: user.first_name,
          last_name: user.last_name,
          document: user.document,
          email: user.email,
          documentType: user.document_type,
        }
      })

      const resultsFailed = response.data.failedUsers.map((user) => {
        return {
          user: {
            firstName: user.first_name,
            lastName: user.last_name,
            document: user.document,
            email: user.email,
            documentType: user.document_type,
            reason: user.reason,
          },
          status: 'error',
        }
      })

      setResultsSucces(resultsSuccess)
      setResultsExisting(existingUsers)
      setResultsFail(resultsFailed)
      setUrlExcelUsersFailed(response?.data?.faild_users_file || '')

      setLoading(false)

      // Retornar los datos directamente para que puedan ser usados inmediatamente en la función que llama
      return {
        resultsSucess: resultsSuccess,
        resultsExisting: existingUsers,
        resultsFail: resultsFailed,
        urlExcelUsersFailed: response?.data?.faild_users_file || '',
      }
    } catch (e) {
      setError('Error creating users batch.')
      setLoading(false)
      throw e // Re-lanzamos el error para manejarlo en la función que llama
    }
  }

  return { createUsersBatch, loading, error, resultsSucess, resultsFail, urlExcelUsersFailed, resultsExisting }
}

export default useCreateUsersBatch
